/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagerUpdateProfileResponse } from "./MemberManagerUpdateProfileResponse";

export type MemberManagerUpdateProfileResponseApiRespoonse = {
  data?: MemberManagerUpdateProfileResponse;
  status?: MemberManagerUpdateProfileResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberManagerUpdateProfileResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
